import { config } from '@config';
import { UserInfo } from './UserInfoContext';

export function buildUserInfoFromIdToken(
  payload: Record<string, any>,
  accessToken: string,
): UserInfo {
  return new UserInfo({
    userId: payload['cognito:username'] ?? payload.sub,
    accessToken,
    email: payload.email,
    name: payload.name,
    groups: payload['cognito:groups'] ?? [],
    userPool: config.userPoolScope,
    isInCall: false,
    moduleOrder: payload['custom:module_order'],
  });
}
